import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Component } from '@verndale/core';
import { Splide } from '@splidejs/splide';
import breakToLines from './breakToLines';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      slider: this.el.querySelector('.swiper-container')
    };

    if (this.el.dataset.experienceEditor === 'true') {
      this.initSwiperBreakToLines();
      this.el.style.visibility = 'visible';
      return this.el.classList.add('experience-editor-slider');
    }

    this.isPeopleSlider = this.el.dataset.isPeopleSlider === 'true';
    this.sliderAuto = this.el.dataset.sliderAuto === 'true';
    this.loopSlides = this.el.dataset.loopSlides === 'true';
    this.initSlider();
  }

  initSlider() {
    const splide = new Splide(this.el, {
      type: this.loopSlides ? 'loop' : 'slide',
      drag: 'free',
      focus: 0,
      lazyLoad: 'sequential',
      perPage: 5,
      gap: 40,
      arrows: false,
      autoScroll: {
        speed: 0.4,
        autoStart: this.sliderAuto,
        pauseOnHover: this.sliderAuto
      },
      autoHeight: true,
      autoWidth: true,
      breakpoints: {
        1025: { perPage: 3, gap: 40, autoWidth: false },
        640: { perPage: this.isPeopleSlider ? 1 : 2, gap: 20, autoWidth: false }
      }
    });

    splide.mount({ AutoScroll });


    splide.on('dragged', () => {
      const autoScroll = splide.Components.AutoScroll;
      if (this.sliderAuto) {
        autoScroll.start();
      } else {
        autoScroll.pause();
      }
    });


    this.initSwiperBreakToLines();
  }

  initSwiperBreakToLines() {
    [
      ...document.querySelectorAll('[data-module="swiperBreakToLines"]')
    ].forEach(element => new breakToLines(element));
  }
}

export default Module;
